<script setup lang="ts">
import type { HTMLAttributes } from "vue";

import { cn } from "../../lib/utils";

interface Props {
  class?: HTMLAttributes["class"];
}

const props = defineProps<Props>();
</script>

<template>
  <header :class="cn('ui-card__header', props.class)">
    <slot />
  </header>
</template>
